import { render } from "./TechnicMaker.vue?vue&type=template&id=0e71bf80"
import script from "./TechnicMaker.vue?vue&type=script&lang=js"
export * from "./TechnicMaker.vue?vue&type=script&lang=js"

import "./TechnicMaker.vue?vue&type=style&index=0&id=0e71bf80&lang=scss"
script.render = render

export default script